import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'underscoresToSpaces'
})

export class UnderscoresToSpacesPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/_/g, ' ');
  }
}
